'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  var asterisk = value.indexOf('*', fromIndex);
  var underscore = value.indexOf('_', fromIndex);

  if (underscore === -1) {
    return asterisk;
  }

  if (asterisk === -1) {
    return underscore;
  }

  return underscore < asterisk ? underscore : asterisk;
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/locate/emphasis.js
// module id = 479
// module chunks = 35783957827783